import BpButton from "./BpButton.vue";
import BpButtonExport from "./BpButtonExport.vue";
import BpCheckbox from "./BpCheckbox";
import BpCheckboxGroup from "./BpCheckboxGroup";
import BpCheckboxesDropdown from "./BpCheckboxesDropdown.vue";
import BpCollapse from "./BpCollapse.vue";
import BpDataTable from "./BpDataTable";
import BpDatePicker from "./BpDatePicker";
import BpDialog from "./BpDialog.vue";
import BpDropdown from "./BpDropdown";
import BpDropdownItem from "./BpDropdownItem";
import BpExportButton from "./BpExportButton.vue";
import BpFilterButton from "./BpFilterButton";
import BpHeader from "./BpHeader.vue";
import BpIcon from "./BpIcon.vue";
import BpInput from "./BpInput";
import BpInputFile from "./BpInputFile";
import BpOptionsMenu from "./BpOptionsMenu.vue";
import BpPaginator from "./BpPaginator";
import BpQrCodeScanner from "./BpQrCodeScanner";
import BpRadio from "./BpRadio";
import BpSelect from "./BpSelect";
import BpSteps from "./BpSteps";
import BpSwitch from "./BpSwitch";
import BpTableHeader from "./BpTableHeader.vue";
import BpTag from "./BpTag.vue";
import BpTooltip from "./BpTooltip";

import { BpTableResponsive } from "./BpTableResponsive/";

export {
  BpButton,
  BpButtonExport,
  BpCheckboxesDropdown,
  BpDropdown,
  BpDropdownItem,
  BpFilterButton,
  BpInputFile,
  BpPaginator,
  BpQrCodeScanner,
  BpSelect,
  BpTableResponsive,
  BpTag,
  BpTooltip
};

import Vue from "vue";

Vue.use({
  install(Vue) {
    const components_list = [
      {
        name: "bp-checkboxes-dropdown",
        component: BpCheckboxesDropdown
      },
      {
        name: "bp-tag",
        component: BpTag
      },
      {
        name: "bp-button",
        component: BpButton
      },
      {
        name: "bp-tooltip",
        component: BpTooltip
      },
      {
        name: "bp-table-responsive",
        component: BpTableResponsive
      },
      {
        name: "bp-input",
        component: BpInput
      },
      {
        name: "bp-qr-code-scanner",
        component: BpQrCodeScanner
      },
      {
        name: "bp-input-file",
        component: BpInputFile
      },
      {
        name: "bp-steps",
        component: BpSteps
      },
      {
        name: "bp-select",
        component: BpSelect
      },
      {
        name: "bp-checkbox",
        component: BpCheckbox
      },
      {
        name: "bp-checkbox-group",
        component: BpCheckboxGroup
      },
      {
        name: "bp-switch",
        component: BpSwitch
      },
      {
        name: "bp-radio",
        component: BpRadio
      },
      {
        name: "bp-dropdown",
        component: BpDropdown
      },
      {
        name: "bp-dropdown-item",
        component: BpDropdownItem
      },
      {
        name: "bp-paginator",
        component: BpPaginator
      },
      {
        name: "bp-filter-button",
        component: BpFilterButton
      },
      {
        name: "bp-dialog",
        component: BpDialog
      },
      {
        name: "bp-icon",
        component: BpIcon
      },
      {
        name: "bp-button-export",
        component: BpButtonExport
      },
      {
        name: "bp-export-button",
        component: BpExportButton
      },
      {
        name: "bp-data-table",
        component: BpDataTable
      },
      {
        name: "bp-table-header",
        component: BpTableHeader
      },
      {
        name: "bp-options-menu",
        component: BpOptionsMenu
      },
      {
        name: "bp-header",
        component: BpHeader
      },
      {
        name: "bp-collapse",
        component: BpCollapse
      },
      {
        name: "bp-date-picker",
        component: BpDatePicker
      }
    ];
    for (let { name, component } of components_list) {
      Vue.component(name, component);
    }
  }
});
